module.exports = __webpack_public_path__ + "img/slide_5.385e5838.jpg";